import React from 'react';
import PropTypes from 'prop-types';
import { useFela } from 'react-fela';
import { largeScreen, smallScreen } from '../../../../../common/mixins';

const rule = ({ theme, thick }) => ({
  background: theme.color.playerProgressTrack,
  height: '8px',
  position: 'absolute',
  left: theme.margin.xxlarge,
  right: theme.margin.xxlarge,
  top: '-10px',
  ':hover .thumb': {
    background: theme.color.light,
    height: '20px',
    width: '20px',
  },
  transition: `height ${theme.transition.default}, left ${theme.transition.default}, right ${theme.transition.default}`,
  extend: [
    largeScreen({
      left: theme.margin.large,
      right: theme.margin.large,
    }),
    smallScreen({
      left: theme.margin.medium,
      right: theme.margin.medium,
    }),
    {
      condition: thick,
      style: {
        height: '4px',
        left: '0',
        right: '0',
      },
    },
  ],
});

const Track = React.forwardRef(({ thick, ...otherProps }, ref) => {
  const { css } = useFela({ thick });

  return (
    <div
      className={css(rule)}
      ref={ref}
      {...otherProps}
      data-cy="hp-progress-bar"
    />
  );
});

Track.displayName = 'Track';

Track.propTypes = {
  thick: PropTypes.bool,
};

export default React.memo(Track);
